export default __webpack_public_path__ + "static/media/camera-added.3fa6aca5.svg";